export * from './ProductOrderedDetailsText.ui';
